import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveIcon from "@mui/icons-material/Remove";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import lineBreak from "../../../utils/lineBreak";

export default function ClickToCallResponse() {
  const { t } = useTranslation();
  const [jsonFinal, setJsonFinal] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const [value, setValue] = useState<any>({
    text: "",
    contact_to_call: "",
    telephone: "",
  });

  const [values, setValues] = useState<any[]>([]);

  const generate = () => {
    const concat = lineBreak(description);
    values.forEach((item) => {
      if (item.text) {
        item.text = item.text.replaceAll("\\n", "\n");
      }
      if (item.contact_to_call) {
        item.contact_to_call = item.contact_to_call.replaceAll("\\n", "\n");
      }
      if (item.telephone) {
        item.telephone = item.telephone.replaceAll("\\n", "\n");
      }
    });

    const jsonGerado = {
      generic: [
        {
          response_type: "text",
          values: [
            {
              text_expression: {
                concat,
              },
            },
          ],
          selection_policy: "sequential",
        },
        {
          user_defined: {
            type: "click_to_call",
            value: {
              click_to_call: {
                options: values,
              },
            },
          },
          response_type: "user_defined",
        },
      ],
    };
    setJsonFinal(JSON.stringify(jsonGerado, null, 2));
  };

  const clear = () => {
    setDescription("");
    setValue({
      text: "",
      contact_to_call: "",
      telephone: "",
    });
    setValues([]);
    setJsonFinal("");
  };

  return (
    <Grid container>
      <Grid container size={12} sx={{ marginBottom: 2 }}>
        <Grid size={12}>
          <TextField
            fullWidth
            size="small"
            id="outlined-basic"
            label={t("transformJson.description")}
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container size={12} spacing={1} sx={{ marginBottom: 2 }}>
        <Grid size={4}>
          <TextField
            fullWidth
            size="small"
            id="outlined-basic"
            label={t("transformJson.text")}
            variant="outlined"
            value={value.text}
            onChange={(e) => setValue({ ...value, text: e.target.value })}
          />
        </Grid>
        <Grid size={4}>
          <TextField
            fullWidth
            size="small"
            id="outlined-basic"
            label={t("transformJson.contactToCall")}
            variant="outlined"
            value={value.contact_to_call}
            onChange={(e) =>
              setValue({ ...value, contact_to_call: e.target.value })
            }
          />
        </Grid>
        <Grid size={3}>
          <TextField
            fullWidth
            size="small"
            id="outlined-basic"
            label={t("transformJson.telephone")}
            variant="outlined"
            value={value.telephone}
            onChange={(e) => setValue({ ...value, telephone: e.target.value })}
          />
        </Grid>
        <Grid size="auto">
          <IconButton
            color="primary"
            aria-label="add"
            disabled={
              value.text !== "" && value.contact_to_call !== "" ? false : true
            }
            onClick={() => {
              setValues([...values, value]);
              setValue({
                text: "",
                contact_to_call: "",
                telephone: "",
              });
            }}
          >
            <AddIcon />
          </IconButton>
        </Grid>
      </Grid>
      {values.map((aux: any, index: number) => {
        return (
          <Grid
            container
            key={`${aux.telephone || "call"}-${index}`}
            sx={{ marginBottom: 2 }}
          >
            <Grid size={4}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                label={t("transformJson.text")}
                variant="outlined"
                value={aux.text || ""}
                onChange={(e) => {
                  const newArr = [...values];
                  newArr[index].text = e.target.value;
                  setValues(newArr);
                }}
              />
            </Grid>
            <Grid size={4}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                label={t("transformJson.contactToCall")}
                variant="outlined"
                value={aux.contact_to_call || ""}
                onChange={(e) => {
                  const newArr = [...values];
                  newArr[index].contact_to_call = e.target.value;
                  setValues(newArr);
                }}
              />
            </Grid>
            <Grid size={3}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                label={t("transformJson.telephone")}
                variant="outlined"
                value={aux.telephone || ""}
                onChange={(e) => {
                  const newArr = [...values];
                  newArr[index].telephone = e.target.value;
                  setValues(newArr);
                }}
              />
            </Grid>
            <Grid size="auto">
              <IconButton
                color="primary"
                aria-label="remove"
                onClick={() => {
                  const newArr = [...values];
                  newArr.splice(index, 1);
                  setValues(newArr);
                }}
              >
                <RemoveIcon />
              </IconButton>
            </Grid>
          </Grid>
        );
      })}
      <Grid container spacing={2} sx={{ marginBottom: 1 }}>
        <Grid>
          <Button
            variant="contained"
            sx={{ marginTop: "8px" }}
            disabled={description === "" || values.length === 0 ? true : false}
            onClick={generate}
          >
            {t("button.Generate")}
          </Button>
        </Grid>
        <Grid>
          <Button variant="contained" sx={{ marginTop: "8px" }} onClick={clear}>
            {t("button.Clean")}
          </Button>
        </Grid>
      </Grid>
      <Grid container size={12} sx={{ flexDirection: "column" }}>
        <Grid>
          <pre
            style={{
              wordWrap: "break-word",
              maxWidth: "37rem",
              whiteSpace: "pre-wrap",
            }}
          >
            {jsonFinal}
          </pre>
        </Grid>
        <Grid>
          {jsonFinal !== "" ? (
            <Button
              disabled={false}
              variant="contained"
              onClick={() => {
                navigator.clipboard.writeText(jsonFinal);
              }}
              startIcon={<ContentCopyIcon />}
            >
              {t("button.Copy")}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
}
